export const siteConfig = {
  name: 'CloudNext',
  legalName: 'Orfeo Hizon',
  abn: process.env.REACT_APP_ABN || '',
  email: 'info@cloudnext.dev',
  phone: process.env.REACT_APP_PHONE || '',
  demoPhone: process.env.REACT_APP_DEMO_PHONE || '',
  location: 'Hervey Bay, Queensland, Australia',
  serviceArea: 'Australia-wide',
  url: 'https://cloudnext.dev',
  linkedin: 'https://www.linkedin.com/company/cloud-next/',
  founderLinkedin: 'https://www.linkedin.com/in/goybs',
  bulletchat: 'https://bulletchat.app',
  upwork: process.env.REACT_APP_UPWORK_URL || 'https://www.upwork.com/freelancers/~01ea7a4a498298fd1f',
};

// Do not say "registered business name" until the ASIC name transfer is complete.
export const legalLine = siteConfig.abn
  ? `CloudNext is a brand operated by ${siteConfig.legalName}, ABN ${siteConfig.abn}.`
  : `CloudNext is a brand operated by ${siteConfig.legalName}.`;

export const introOfferEnds = '31 December 2026';
export const standardPricingFrom = '1 January 2027';

export const pricing = {
  websiteChatbot: {
    setup: '700',
    standardSetup: '1400',
    monthly: '49',
    standardMonthly: '69',
  },
  websiteChatbotVoice: {
    setup: '950',
    standardSetup: '1900',
    monthly: '79',
    standardMonthly: '119',
    proMonthly: '199',
    proStandardMonthly: '299',
    minutes: '300',
    proMinutes: '1000',
    overage: '0.30',
    proOverage: '0.18',
  },
};

export const formatPrice = (value) => {
  if (!value) return null;
  const numeric = String(value).replace(/[^0-9.]/g, '');
  if (!numeric) return String(value);
  const formatted = Number(numeric).toLocaleString('en-AU');
  return `$${formatted}`;
};
